module.exports = "<li class=\"kl-dropdown-item\"\n    r-class=\"{{'kl-dropdown-item--disabled': disabled,'kl-dropdown-item--selected': selected,'kl-dropdown-item--divided': divided}}\"\n    on-click=\"{this.onClick()}\">\n    {#inc this.$body}\n</li>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLDrop/KLDropItem/index.html
// module id = 571
// module chunks = 0